import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=60ff3a3d&"
import script from "./FileCard.vue?vue&type=script&lang=js&"
export * from "./FileCard.vue?vue&type=script&lang=js&"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=60ff3a3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports